"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setQuery = exports.removeQuery = exports.getQuery = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var MODULE_NAME = 'sdk/browser/utils/query';

var logger = _loglevel.default.getLogger(MODULE_NAME);
/**
 *
 * @param {string} name
 * @returns {string}
 */


var getQuery = function getQuery(name) {
  logger.info("".concat(MODULE_NAME, " - getQuery called"), {
    name: name,
    location: window.location
  });
  var updatedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(updatedName, "=([^&#]*)"));
  var results = regex.exec(window.location.search);
  var param = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  logger.debug("".concat(MODULE_NAME, " - getQuery param"), param);
  return param;
};
/**
 *
 * @param {string} name
 */


exports.getQuery = getQuery;

var removeQuery = function removeQuery(name) {
  logger.info("".concat(MODULE_NAME, " - removeQuery called"), {
    name: name,
    location: window.location
  });
  var value = getQuery(name);

  if (value) {
    var search = window.location.search;
    search = search.replace("&".concat(name, "=").concat(value), '');
    search = search.replace("".concat(name, "=").concat(value, "&"), '');

    if (search) {
      search = search.replace("?".concat(name, "=").concat(value), '');
    }

    window.history.pushState({
      path: window.location.origin + window.location.pathname + search
    }, '', window.location.origin + window.location.pathname + search);
  }
};
/**
 *
 * @param {{name: string, value: string|number}} params
 */


exports.removeQuery = removeQuery;

var setQuery = function setQuery(params) {
  logger.info("".concat(MODULE_NAME, " - setQuery called"), {
    params: params,
    location: window.location
  });
  var search = '';

  if (!window.location.search) {
    search += '?';
  } else {
    search += '&';
  }

  search += "".concat(params.name, "=").concat(params.value);
  window.history.pushState({
    path: window.location + search
  }, '', window.location + search);
};

exports.setQuery = setQuery;